import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanTimelineRoute: InvariantJiraRoute = {
	name: 'software-plan-timeline',
	path: '/jira/plans/:planId/scenarios/:scenarioId/timeline',
};
